import { Button, Column, Modal, Typography } from '@tempmee/react';
import { OutlineCheckCircleConfirmationIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';

export interface IResetSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  testId?: string;
}

const MODAL_WIDTH = 500;
const MODAL_PADDING = 30;
const BUTTON_RADIUS = 999;

export const ResetSuccessModal = ({
  isOpen,
  onClose,
  testId = 'reset-success-modal',
}: IResetSuccessModalProps) => (
  <Modal
    open={isOpen}
    onClose={onClose}
    size="lg"
    data-testid={testId}
    style={{ width: MODAL_WIDTH, maxWidth: MODAL_WIDTH }}
  >
    <Column align="center" gap={6} style={{ padding: MODAL_PADDING }}>
      <OutlineCheckCircleConfirmationIcon size={80} color={colors.success[400]} />

      <Column align="center" style={{ gap: 6 }}>
        <Typography
          as="span"
          bold
          color={colors.neutral[600]}
          textAlign="center"
          style={{ fontSize: 18 }}
        >
          Password Successfully Updated!
        </Typography>
        <Typography size="body_large" color={colors.neutral[500]} textAlign="center">
          Your password has been updated successfully.
        </Typography>
      </Column>

      <Button
        data-cy="btn-close-reset-success-modal"
        type="button"
        variant="primary"
        size="md"
        onClick={onClose}
        style={{ borderRadius: BUTTON_RADIUS }}
      >
        Close
      </Button>
    </Column>
  </Modal>
);
